import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
var _hoisted_1 = ["onClick"];
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  key: 0
};
import { getCurrentInstance } from "vue";
export default {
  __name: 'recursiveComponent',
  props: {
    tree: {
      type: Array,
      required: true
    },
    childKey: {
      type: String,
      default: 'children'
    },
    labelKey: {
      type: String,
      default: 'name'
    },
    key_: {
      type: String,
      default: 'id'
    },
    collapsedKey: {
      type: String,
      default: 'collapsed'
    },
    active: {
      type: String
    }
  },
  emits: ['transferActiveNode'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var instance = getCurrentInstance();
    var toggleNode = node => {
      node[props.collapsedKey] = !node[props.collapsedKey];
      // 强制组件更新
      instance.proxy.$forceUpdate();
    };
    // 双击某元素时表示选中
    var handle_dbclick = node => {
      emit("transferActiveNode", node);
    };
    return (_ctx, _cache) => {
      var _component_recursive_component = _resolveComponent("recursive-component", true);
      return _openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tree, node => {
        var _node$props$childKey, _node$props$childKey2;
        return _openBlock(), _createElementBlock("div", {
          key: node[props.key_]
        }, [_createElementVNode("div", {
          class: _normalizeClass({
            'item': true,
            'active': props.active == node[props.key_],
            'default': props.active != node[props.key_]
          }),
          onClick: $event => handle_dbclick(node),
          style: _normalizeStyle({
            'padding-left': node['level'] * 10 + 10 + 'px'
          })
        }, [node[props.childKey] && (_node$props$childKey = node[props.childKey]) !== null && _node$props$childKey !== void 0 && _node$props$childKey.length ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: _normalizeClass({
            'iconfont': true,
            'icon-jiantouxia': !node[props.collapsedKey],
            'icon-jiantoushang': node[props.collapsedKey]
          }),
          onClick: _withModifiers($event => toggleNode(node), ["stop"])
        }, null, 10, _hoisted_2)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass({
            'iconfont': true,
            'icon-jiantouxia': !node[props.collapsedKey],
            'icon-jiantoushang': node[props.collapsedKey]
          }),
          style: {
            "opacity": "0"
          }
        }, null, 2)), _createElementVNode("span", {
          class: _normalizeClass({
            'txt': true,
            top: node['level'] == 0,
            second: node['level'] == 1
          }),
          style: _normalizeStyle({
            fontSize: 15 - (node['level'] + 1) + 'px'
          })
        }, _toDisplayString(node[props.labelKey]), 7)], 14, _hoisted_1), node[props.childKey] && ((_node$props$childKey2 = node[props.childKey]) === null || _node$props$childKey2 === void 0 ? void 0 : _node$props$childKey2.length) > 0 && node[props.collapsedKey] ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_recursive_component, {
          childKey: props.childKey,
          labelKey: props.labelKey,
          expandedKey: props.collapsedKey,
          tree: node[props.childKey],
          onTransferActiveNode: handle_dbclick,
          active: props.active
        }, null, 8, ["childKey", "labelKey", "expandedKey", "tree", "active"])])) : _createCommentVNode("", true)]);
      }), 128))]);
    };
  }
};